import { BONUS_CAMPAIGN_TYPE } from '../../../constants/enums';
import CampaignBonusReportsPage, { type CampaignBonusReportsPageProps } from './CampaignBonusReportsPage';

type CashbackBonusReportsPageProps = Omit<CampaignBonusReportsPageProps, 'bonusType'>;

const CashbackBonusReportsPage = (props: CashbackBonusReportsPageProps) => {
  return <CampaignBonusReportsPage {...props} bonusType={BONUS_CAMPAIGN_TYPE.CASHBACK} />;
};

export default CashbackBonusReportsPage;
